module.exports = __webpack_public_path__ + "img/minecart.062e992e.svg";